import { type ReactNode } from 'react'
import { Head } from '@inertiajs/react'
import AdminLayout from '@/components/AdminLayout'
import BlogCategoryForm, { type BlogCategoryFormData } from '@/components/admin/BlogCategoryForm'

type Props = {
  category: {
    id: string
    name: string
    slug: string
    description: string | null
    position: number
  }
  errors?: Partial<Record<string, string[] | string>>
}

export default function AdminBlogCategoriesEdit({ category, errors }: Props) {
  const initialData: BlogCategoryFormData = {
    name: category.name,
    slug: category.slug,
    description: category.description || '',
    position: category.position,
  }
  return (
    <>
      <Head title={`Admin · Edit ${category.name}`} />
      <BlogCategoryForm initialData={initialData} categoryId={category.id} errors={errors} />
    </>
  )
}

AdminBlogCategoriesEdit.layout = (page: ReactNode) => <AdminLayout>{page}</AdminLayout>
